import React from 'react'
import ConnectorIcon from '../../../../../../SharedComponents/ConnectorIcon/ConnectorIcon'

const ConnectorImage = ({ sourceShortName, targetShortName }) => (
    <div className="connector-card-icons">
        <div className="img-cont-full img-cont-1">
            <ConnectorIcon shortName={sourceShortName} fallbackClassName="imgPlaceholderNew" />
        </div>
        <div className="img-cont-full img-cont-2">
            <ConnectorIcon shortName={targetShortName} fallbackClassName="imgPlaceholderNew" decorative />
        </div>
    </div>
)

export default ConnectorImage
